import {
  ExclamationCircleOutlined,
  VideoCameraTwoTone,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Collapse,
  Empty,
  message,
  Modal,
  Pagination,
  Space,
} from "antd";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useQuery } from "../../common/utils";
import { CountDown, Icon, Menu } from "../../components/index";
import liveIcon from "../../img/live-icon.png";
import no_class from "../../img/no_class.png";
import projectDefault from "../../img/project_default.jpg";
import project_bg from "../../img/project_bg.png";
import {
  checkSaleActivityCourseExam,
  checkSaleActivityProjectExam,
  checkSaleActivityTopicCourseExam,
  fetchSaleActivityProjectCourseList,
  fetchSaleActivityProjectInfo,
  fetchSaleActivityProjectTopicList,
  getSaleActivityCourseQuestionnaireUrl,
  getSaleActivityProjectExamPaperInfo,
  getSaleActivityProjectQuestionnaireUrl,
  getSaleActivityTopicCourseQuestionnaireUrl,
  saveSaleActivityProjectReadNotice,
} from "./api";
import { SaleActivityCourseInfo, SaleActivityProjectInfo } from "./types";
import "../projectInfo/project-info.scss";
import "./activity.scss";

const { Panel } = Collapse;

const QuestionStatus: any = {
  0: "不可以调查问卷",
  1: "可以调查问卷",
  2: "完成调查问卷",
};

const trainStatus = new Map([
  [0, "未通过"],
  [1, "未通过"],
  [2, "已通过"],
  [4, "未通过"],
  [7, "未通过"],
]);

const topicProjectStatus = new Map([
  [0, "未开始"],
  [1, "进行中"],
  [2, "已结束"],
  [3, "未结束"],
]);

const navList = [
  { title: "培训须知", sub: "1", icon: "bullhorn", disabled: false },
  { title: "课程列表", sub: "2", icon: "list-ul", disabled: true },
  { title: "问卷考试", sub: "3", icon: "landmark", disabled: true },
];

const getFirstSectionId = (item: any) => {
  const section = item?.sectionList && item.sectionList[0];
  return section?.id || item?.sectionId;
};

const getDataList = (data: any) =>
  data?.courseList || data?.topicDetailList || data?.topicInfoList || data?.list || [];

export default function SaleActivityProjectInfoPage() {
  const query = useQuery();
  const history = useHistory();
  const saleActivityId = query.get("saleActivityId") || "";
  const projectId = query.get("projectId") || "";
  const [navIndex, setNavIndex] = useState("0");
  const [navlist, setNavList] = useState(navList);
  const [projectInfo, setProjectInfo] = useState<SaleActivityProjectInfo | any>({});
  const [courseList, setCourseList] = useState<SaleActivityCourseInfo[]>([]);
  const [topicList, setTopicList] = useState<any[]>([]);
  const [hasReadFlag, setHasReadFlag] = useState(false);
  const [courseStudyTimeFlag, setCourseStudyTimeFlag] = useState(1);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const pageSize = 15;

  const unlockNav = () => {
    setNavList((list) =>
      list.map((item, index) =>
        index > 0 ? { ...item, disabled: false } : item
      )
    );
  };

  const loadCourseList = (currentPage = 1) => {
    fetchSaleActivityProjectCourseList({
      saleActivityId,
      projectId,
      page: { currentPage, pageSize },
    }).then((res) => {
      const data = res.data || {};
      const list = (data.courseList || data.list || []).map((item: any) => ({
        ...item,
        progress: Number(item.progress || 0),
      }));
      setCourseList(list);
      setTotal(data.page?.totalResultSize || list.length || 0);
      setPage(data.page?.currentPage || currentPage);
    });
  };

  const loadTopicList = () => {
    fetchSaleActivityProjectTopicList({
      saleActivityId,
      projectId,
    }).then((res) => {
      const data = res.data || {};
      setTopicList(getDataList(data).filter((item: any) => item.hasLearnAuthorityFlag !== 0));
    });
  };

  const openTopicCourseList = (topic: any) => {
    if (!topic.topicId) {
      message.info("专题信息异常，暂无可进入课程");
      return;
    }
    if (topic.studyStatus !== undefined && Number(topic.studyStatus) !== 1) {
      message.info(`专题时间${topic.studyStatusText || topicProjectStatus.get(Number(topic.studyStatus)) || "不可学习"}`);
      return;
    }
    history.push(`/saleActivityTopicInfo?saleActivityId=${saleActivityId}&projectId=${projectId}&topicId=${topic.topicId}`);
  };

  const loadProjectInfo = () => {
    fetchSaleActivityProjectInfo({ saleActivityId, projectId }).then((res) => {
      const data = res.data?.projectInfo || res.data || {};
      setProjectInfo(data);
      setCourseStudyTimeFlag(data.courseStudyTimeFlag ?? 1);
      const hasRead = data.mustReadNoticeFlag === 1 && data.hasReadNoticeFlag === 0;
      setHasReadFlag(hasRead);
      if (!hasRead) {
        unlockNav();
        setNavIndex("1");
      }
      if ((data.courseForm || 1) === 1) {
        loadCourseList(1);
      } else {
        loadTopicList();
      }
    });
  };

  useEffect(() => {
    if (!saleActivityId || !projectId) return;
    loadProjectInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saleActivityId, projectId]);

  const saveReadNotice = () => {
    saveSaleActivityProjectReadNotice({ saleActivityId, projectId }).then((res) => {
      if (res.code === 0 || res.code === 200 || res.code === 2000) {
        message.success("已阅读");
        unlockNav();
        setHasReadFlag(false);
        setNavIndex("1");
      }
    });
  };

  const playCourse = (item: any, topicId?: string | number) => {
    const sectionId = getFirstSectionId(item);
    if (!sectionId) {
      message.info("暂无可播放章节");
      return;
    }
    const topicParam = topicId || item.topicId;
    history.push(
      `/play?type=saleActivity&saleActivityId=${saleActivityId}&projectId=${projectId}&courseId=${item.courseId}&sectionId=${sectionId}${
        topicParam ? `&topicId=${topicParam}` : ""
      }&onlyPlay=1`
    );
  };

  const openLiveRoom = (item: any, topicId?: string | number) => {
    const section = item.sectionList && item.sectionList[0];
    const { roomId, ccUserId } = section || {};
    if (!roomId || !ccUserId) {
      message.info("暂无直播地址");
      return;
    }
    const topicParam = topicId || item.topicId;
    window.open(
      `/shop/ccLiveFunction/getUserProjectLiveUrl?roomId=${roomId}&ccUserId=${ccUserId}${
        topicParam ? `&topicId=${topicParam}` : ""
      }`
    );
  };

  const jumpLiveRoom = (item: any, topicId?: string | number) => {
    if (!item.sectionList || item.sectionList.length === 0) return;
    if (item.courseType === "live") {
      openLiveRoom(item, topicId);
      return;
    }
    playCourse(item, topicId);
  };

  const getCourseQuestionnaire = (item: any, topicId?: string | number) => {
    const questionnaireStatus = item.questionnaireStatus;
    if (questionnaireStatus === 0 || questionnaireStatus === 2) {
      message.info(QuestionStatus[questionnaireStatus]);
      return;
    }
    const params: any = {
      saleActivityId,
      projectId,
      courseId: item.courseId,
    };
    const topicParam = topicId || item.topicId;
    if (topicParam) {
      params.topicId = topicParam;
      getSaleActivityTopicCourseQuestionnaireUrl(params).then((res) => {
        const url = res.data?.questionnaireUrl;
        if (url) window.location.href = url;
      });
      return;
    }
    getSaleActivityCourseQuestionnaireUrl(params).then((res) => {
      const url = res.data?.questionnaireUrl;
      if (url) window.location.href = url;
    });
  };

  const getProjectQuestionnaire = () => {
    const questionnaireStatus = projectInfo?.projectQuestionnaireInfo?.questionnaireStatus;
    if (questionnaireStatus === 0 || questionnaireStatus === 2) {
      message.info(QuestionStatus[questionnaireStatus]);
      return;
    }
    getSaleActivityProjectQuestionnaireUrl({ saleActivityId, projectId }).then((res) => {
      const url = res.data?.questionnaireUrl;
      if (url) window.location.href = url;
    });
  };

  const openProjectExam = (item: any) => {
    checkSaleActivityProjectExam({
      saleActivityId,
      projectId,
      examManagerId: item.examManagerId,
    }).then((res) => {
      const data = res.data || {};
      const go = () => {
        if (data.projectCanExamNum === 0 && data.projectExamLimitFlag === 1) return;
        getSaleActivityProjectExamPaperInfo({
          saleActivityId,
          projectId,
          examManagerId: item.examManagerId,
        }).then(() => {
          const { REACT_APP_BASE_URL, REACT_APP_EXAM_URL } = process.env;
          window.location.href = `${REACT_APP_BASE_URL}${REACT_APP_EXAM_URL}/exam-list/examList?fromType=saleActivityProjectExam&projectId=${projectId}&saleActivityId=${saleActivityId}&examManagerId=${item.examManagerId || ""}`;
        });
      };
      if (data.projectExamLimitFlag === 1) {
        Modal.confirm({
          title: "提示",
          icon: <ExclamationCircleOutlined />,
          content: (
            <div style={{ fontSize: "16px" }}>
              <p>
                本场共 <span style={{ fontSize: "24px", color: "red" }}>{data.projectExamLimitNum}</span> 次机会
              </p>
              <p>
                当前剩余 <span style={{ fontSize: "24px", color: "red" }}>{data.projectCanExamNum}</span> 次
              </p>
            </div>
          ),
          onOk: go,
        });
      } else {
        go();
      }
    });
  };

  const openCourseExam = (item: any, topicId?: string | number) => {
    const params: any = {
      saleActivityId,
      projectId,
      courseId: item.courseId,
    };
    const topicParam = topicId || item.topicId;
    if (topicParam) {
      params.topicId = topicParam;
      checkSaleActivityTopicCourseExam(params).then((res) => {
        const data = res.data || {};
        if (data.courseCanExamNum === 0 && data.courseExamLimitFlag === 1) return;
        const { REACT_APP_BASE_URL, REACT_APP_EXAM_URL } = process.env;
        window.location.href = `${REACT_APP_BASE_URL}${REACT_APP_EXAM_URL}/exam-list/examList?fromType=saleActivityCourseExam&projectId=${projectId}&saleActivityId=${saleActivityId}&courseId=${item.courseId}&topicId=${topicParam}`;
      });
      return;
    }
    checkSaleActivityCourseExam(params).then((res) => {
      const data = res.data || {};
      if (data.courseCanExamNum === 0 && data.courseExamLimitFlag === 1) return;
      const { REACT_APP_BASE_URL, REACT_APP_EXAM_URL } = process.env;
      window.location.href = `${REACT_APP_BASE_URL}${REACT_APP_EXAM_URL}/exam-list/examList?fromType=saleActivityCourseExam&projectId=${projectId}&saleActivityId=${saleActivityId}&courseId=${item.courseId}${
        item.topicId ? `&topicId=${item.topicId}` : ""
      }`;
    });
  };

  const renderCourseItem = (item: any, idx: number, topicId?: string | number) => (
    <div
      className={item.courseLock ? "video_item_box_mask video_item_box" : "video_item_box"}
      key={`${item.courseId || idx}-${topicId || ""}`}
    >
      <p
        onClick={() => jumpLiveRoom(item, topicId)}
        style={{ cursor: item.sectionList?.length ? "pointer" : "default" }}
      >
        <h5 style={{ display: "flex", alignItems: "center" }}>
          <VideoCameraTwoTone twoToneColor={item.courseType === "live" ? "red" : ""} />
          &emsp;
          <span style={{ color: "#1890ff" }}>{item.courseOrder || idx + 1}</span>
          &emsp;
          <span dangerouslySetInnerHTML={{ __html: item.courseName || "--" }} />
          {item.courseType === "live" && (
            <img src={liveIcon} alt="" style={{ width: "46px", marginLeft: "4px" }} />
          )}
        </h5>
      </p>
      <div className="studyProgress_box">
        <p style={{ opacity: item.courseType === "live" ? 0 : 1 }}>
          {!item.onlyPdfFlag && (
            <>
              <span>课程时长：{item.courseDurationText || "--"}</span>
              <span>&emsp;学习进度:{item.progress || 0}%</span>
            </>
          )}
          {item.userGetCourseCreditText && <span>&emsp;学分：{item.userGetCourseCreditText}</span>}
          {projectInfo.showCourseExamStatusFlag === 1 &&
            item.courseExamShowFlag === 1 &&
            item.hasExamFlag === 1 && <span>&emsp;练习状态:{trainStatus.get(item.examStatus)}</span>}
        </p>
        <Space>
          {item.hasQuestionnaireFlag === 1 && (
            <Button type="primary" size="small" onClick={() => getCourseQuestionnaire(item, topicId)}>
              评价
            </Button>
          )}
          {item.courseExamShowFlag === 1 && item.hasExamFlag === 1 && (
            <Button
              type="primary"
              size="small"
              disabled={item.examStatus === 0}
              onClick={() => openCourseExam(item, topicId)}
            >
              练习
            </Button>
          )}
          {item.sectionList?.length > 0 && (
            <Button type="primary" size="small" onClick={() => jumpLiveRoom(item, topicId)}>
              播放
            </Button>
          )}
        </Space>
      </div>
    </div>
  );

  const renderCourseList = () => {
    if (courseStudyTimeFlag === 0 && projectInfo.projectStatus === 1) {
      return (
        <div style={{ textAlign: "center" }}>
          <h3>不在学习时间范围内</h3>
          <h4>
            学习时间：{projectInfo.courseStudyBeginTimeText} - {projectInfo.courseStudyEndTimeText}
          </h4>
        </div>
      );
    }
    if (projectInfo.projectStatus !== undefined && projectInfo.projectStatus !== 1) {
      return (
        <div className="no_class">
          <img src={no_class} alt="未在项目开放周期内" />
          <p>未在项目开放周期内</p>
        </div>
      );
    }
    if ((projectInfo.courseForm || 1) === 2) {
      if (!topicList.length) {
        return (
          <div className="no_class">
            <img src={no_class} alt="暂无专题" />
            <p>暂无专题课程</p>
          </div>
        );
      }
      if ((projectInfo.topicShowForm || 1) === 1) {
        return (
          <Collapse accordion className="my-accordion" defaultActiveKey={["0"]}>
            {topicList.map((topic, index) => (
              <Panel header={topic.topicName} className="pad" key={index}>
                {(topic.courseInfoList || []).map((item: any, idx: number) =>
                  renderCourseItem(item, idx, topic.topicId)
                )}
              </Panel>
            ))}
          </Collapse>
        );
      }
      return (
        <div className="topicInfoContainer">
          {topicList.map((item, key) => (
            <div
              key={key}
              onClick={() => openTopicCourseList(item)}
              style={{ width: "270px", margin: "12px" }}
            >
              <img src={item.topicImage || projectDefault} alt="" width="100%" />
              {item.topicTimeRange && <span className="range">{item.topicTimeRange}</span>}
              <h6>{item.topicName}</h6>
              <p className="topic_progress">
                {item.topicDurationText !== "00:00:00" && <span>专题时长：{item.topicDurationText}</span>}
                {Number(item.topicProgress) > 0 && <span>学习进度：{item.topicProgress}%</span>}
              </p>
            </div>
          ))}
        </div>
      );
    }
    if (!courseList.length) {
      return (
        <div className="no_class">
          <img src={no_class} alt="暂无课程" />
          <p>暂无课程</p>
        </div>
      );
    }
    return (
      <>
        {courseList.map((item, idx) => renderCourseItem(item, idx))}
        <div className="pagination-box">
          <h6>共{total}门课程</h6>
          <Pagination
            total={total}
            current={page}
            defaultPageSize={pageSize}
            showSizeChanger={false}
            onChange={(current) => loadCourseList(current)}
          />
        </div>
      </>
    );
  };

  const projectQuestionnaireInfo = projectInfo.projectQuestionnaireInfo;
  const projectExamInfoList = projectInfo.projectExamInfoList || [];
  const projectPicture = projectInfo.projectPicture || projectInfo.pictureUrl || projectDefault;

  return (
    <div className="projectInfo_box sale-activity-project-info">
      <div className="project_header">
        <img className="header_img" src={project_bg} alt="" />
        <div className="project_title">
          <Breadcrumb
            separator="/"
            style={{ fontSize: "20px", marginBottom: "30px" }}
          >
            <Breadcrumb.Item href="/#/train">首页</Breadcrumb.Item>
            <Breadcrumb.Item href="/#/personal">我的活动</Breadcrumb.Item>
            <Breadcrumb.Item>
              <span style={{ color: "#1890ff" }}>活动点播项目</span>
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="project_detail_box">
            <img src={projectPicture} alt="" style={{ width: "469px", height: "300px" }} />
            <div style={{ paddingLeft: "20px" }}>
              <h2>{projectInfo.projectName || "--"}</h2>
              <div className="time">
                {(projectInfo.showProjectTimeRangeFlag === 1 || projectInfo.projectTimeRange) && (
                  <p>培训时间：{projectInfo.projectTimeRange || "--"}</p>
                )}
                <div style={{ display: "flex" }}>
                  {(projectInfo.showCourseDurationFlag === 1 || projectInfo.projectDurationText) && (
                    <p style={{ width: "45%" }}>课程时长：{projectInfo.projectDurationText || "--"}</p>
                  )}
                  {(projectInfo.showWatchTimeFlag === 1 || projectInfo.projectWatchTimeText) && (
                    <p>已学时长：{projectInfo.projectWatchTimeText || "--"}</p>
                  )}
                </div>
                <div>
                  {(projectInfo.showCourseCountFlag === 1 || projectInfo.projectCourseCount !== undefined) && (
                    <p style={{ width: "45%" }}>课程数量：{projectInfo.projectCourseCount || 0}</p>
                  )}
                  {(projectInfo.showLearnedCourseCountFlag === 1 || projectInfo.projectLearnedCourseCount !== undefined) && (
                    <p>课程学完数量：{projectInfo.projectLearnedCourseCount || 0}</p>
                  )}
                </div>
                <div>
                  {(projectInfo.showCourseExamCountFlag === 1 || projectInfo.projectCourseExamCount !== undefined) && (
                    <p style={{ width: "45%" }}>练习数量：{projectInfo.projectCourseExamCount || 0}</p>
                  )}
                  {(projectInfo.showFinishCourseExamCountFlag === 1 ||
                    projectInfo.projectFinishCourseExamCount !== undefined) && (
                    <p>练习通过数量：{projectInfo.projectFinishCourseExamCount || 0}</p>
                  )}
                </div>
                <div>
                  {(projectInfo.showLearnProgressFlag === 1 || projectInfo.projectProgress !== undefined) && (
                    <p style={{ width: "45%" }}>学习进度：{projectInfo.projectProgress || 0}%</p>
                  )}
                </div>
                <div>
                  {projectInfo.showEvaluateCountFlag === 1 && (
                    <p style={{ width: "45%" }}>评分数量：{projectInfo.userEvaluateCount || 0}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="project_list">
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <Menu
                index={navIndex}
                defaultOpenSubMenus={[]}
                mode="horizontal"
                onSelect={(index) => setNavIndex(index)}
              >
                {navlist.map((it, index) => (
                  <Menu.Item key={index} disabled={it.disabled}>
                    <Icon icon={it.icon as any} size="1x" theme="dark" style={{ marginRight: "8px" }} />
                    <span>{it.title}</span>
                  </Menu.Item>
                ))}
              </Menu>
            </div>
            <div className="video_box">
              {navIndex === "0" && (
                <>
                  {projectInfo.projectNotice ? (
                    <div
                      dangerouslySetInnerHTML={{ __html: projectInfo.projectNotice }}
                      style={{ padding: "6px 12px", width: "100%", overflowWrap: "anywhere" }}
                    />
                  ) : (
                    <Empty description="暂无培训须知" />
                  )}
                  {hasReadFlag && (
                    <CountDown time={projectInfo.readNoticeTime || 0} sureClick={saveReadNotice} />
                  )}
                </>
              )}
              {navIndex === "1" && renderCourseList()}
              {navIndex === "2" && (
                <div className="examInfo_box">
                  {projectQuestionnaireInfo && (
                    <div>
                      <p>项目问卷</p>
                      <p style={{ display: "flex", justifyContent: "space-between" }}>
                        <span>状态：{QuestionStatus[projectQuestionnaireInfo.questionnaireStatus]}</span>
                        <Button
                          type="primary"
                          disabled={
                            projectQuestionnaireInfo.questionnaireStatus === 0 ||
                            projectQuestionnaireInfo.questionnaireStatus === 2
                          }
                          onClick={getProjectQuestionnaire}
                        >
                          进入问卷
                        </Button>
                      </p>
                    </div>
                  )}
                  {projectExamInfoList.map((item: any, index: number) => (
                    <div key={index}>
                      <p>{item.examPaperName || "项目考试"}</p>
                      <p style={{ display: "flex", justifyContent: "space-between" }}>
                        <span>状态：{item.examStatusText || "--"}</span>
                        <Button
                          type="primary"
                          disabled={
                            item.examStatus === 0 ||
                            item.examStatus === 10 ||
                            item.examStatus === 6 ||
                            item.examStatus === 7
                          }
                          onClick={() => openProjectExam(item)}
                        >
                          进入考试
                        </Button>
                      </p>
                    </div>
                  ))}
                  {!projectQuestionnaireInfo && !projectExamInfoList.length && (
                    <div className="no_class">
                      <img src={no_class} alt="暂无相关信息" />
                      <p>暂无相关信息</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
